module.exports = __webpack_public_path__ + "static/coming-soon-2204938f912023f84e68fefb1141d95a.png";